// Payment reference (UTR, cheque number or note) shown on a paid payout line (item 200). Same rule as the mobile app.
// Trims, collapses spaces and clips long text. Returns '' when there is nothing to show. No imports.
const MAX = 40;

export function payoutRefLabel(reference) {
  if (typeof reference !== 'string') return '';
  const t = reference.replace(/\s+/g, ' ').trim();
  if (!t) return '';
  return 'Ref: ' + (t.length > MAX ? t.slice(0, MAX - 3) + '...' : t);
}
